import React from "react";
import { ALARM_PRIORITY, ALARM_TYPE } from "./Alarms";
import {
    AlarmNameCell,
    ChipList,
    ContactList,
    CreatedByCell,
    PriorityTag,
    alarmTypeChipIcon,
    emailListIcon,
    hotelChipIcon,
    phoneListIcon,
} from "./tableCells";

// ─── Column factory ───────────────────────────────────────────────────────────

const alarmHistoryColumn = (hotels) => {
    const getPriorityLabel = (value) =>
        ALARM_PRIORITY.find((e) => e.value == value)?.name ?? "";

    const getAlarmTypeLabel = (key) =>
        ALARM_TYPE.find((e) => e.key == key)?.title ?? "";

    return [
        {
            title: "Alarm Name",
            dataIndex: "alarm_name",
            key: "alarm_name",
            sorter: (a, b) => a.alarm_name.localeCompare(b.alarm_name),
            render: (val) => <AlarmNameCell value={val} />,
        },
        {
            title: "Hotel Names",
            dataIndex: "alarm_hotel_ids",
            key: "alarm_hotel_ids",
            render: (ids) => {
                const hotelNames = ids?.map(
                    (id) =>
                        hotels?.data?.find((h) => h.hotel_id == id)?.hotel_name,
                );

                return (
                    <ChipList
                        items={hotelNames}
                        icon={hotelChipIcon}
                        bg="var(--color-primary-light)"
                        border="var(--color-border)"
                        color="var(--color-primary)"
                    />
                );
            },
        },
        {
            title: "Emails",
            dataIndex: "alarm_email_ids",
            key: "alarm_email_ids",
            render: (emails) => (
                <ContactList items={emails} icon={emailListIcon} />
            ),
        },
        {
            title: "Phone Numbers",
            dataIndex: "alarm_phone_numbers",
            key: "alarm_phone_numbers",
            render: (phones) => (
                <ContactList items={phones} icon={phoneListIcon} />
            ),
        },
        {
            title: "Priority",
            dataIndex: "priority",
            key: "priority",
            sorter: (a, b) => a.priority - b.priority,
            render: (val) => <PriorityTag label={getPriorityLabel(val)} />,
        },
        {
            title: "Alarm Types",
            dataIndex: "alarm_type",
            key: "alarm_type",
            render: (types) => {
                const alarmTypes = types?.map((t) => getAlarmTypeLabel(t));

                return (
                    <ChipList
                        items={alarmTypes}
                        icon={alarmTypeChipIcon}
                        bg="var(--color-accent-light)"
                        border="var(--color-border)"
                        color="var(--color-accent)"
                    />
                );
            },
        },
        {
            title: "Created By",
            key: "created_by",
            render: (_, record) => (
                <CreatedByCell
                    firstName={record.staff_first_name}
                    lastName={record.staff_last_name}
                />
            ),
        },
    ];
};

export default alarmHistoryColumn;
